"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreightOption = void 0;
exports.FreightOption = {
    DROP_TRAILER: 'DROP_TRAILER',
    FLOOR_LOADED_UNLOAD: 'FLOOR_LOADED_UNLOAD',
    LIVE_UNLOAD: 'LIVE_UNLOAD'
};
//# sourceMappingURL=freight-option.js.map